export function groupBy<T, R>(object: T[], fn: (item: T) => R): { [key: string]: T[] } {
  return object.reduce((acc, value) => {
    /* istanbul ignore next */
    const key = fn(value)?.toString() ?? '';
    acc[key] = (acc[key] || []).concat(value);
    return acc;
  }, {} as { [key: string]: T[] });
}
